"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.setAnswerById = exports.revertToChatStep = exports.askQuestionById = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _xstate = require("xstate");
const askQuestionById = id => (0, _xstate.assign)({
  chat: ctx => {
    var _context2;
    if (!ctx.stepConfigById[id]) {
      var _context;
      return (0, _concat.default)(_context = ctx.chat).call(_context, '');
    }
    return (0, _concat.default)(_context2 = ctx.chat).call(_context2, ctx.stepConfigById[id]);
  }
});
exports.askQuestionById = askQuestionById;
const setAnswerById = id => (0, _xstate.assign)({
  chat: (ctx, ev) => {
    var _context3;
    return (0, _map.default)(_context3 = ctx.chat).call(_context3, c => {
      if (c.id === id) {
        return {
          ...c,
          answer: ev.value
        };
      }
      return c;
    });
  }
});
exports.setAnswerById = setAnswerById;
const revertToChatStep = exports.revertToChatStep = (0, _xstate.assign)({
  chat: (ctx, ev) => {
    var _context4, _context5;
    const stepIndex = (0, _findIndex.default)(_context4 = ctx.chat).call(_context4, chatItem => chatItem.id === ev.id);
    return (0, _slice.default)(_context5 = ctx.chat).call(_context5, 0, stepIndex);
  }
});